<!-- DATA -->
<tec-collapse
    [icon]="'icon-capture-popup'"
    [title]="'OPERATIONS.DETAIL.TABS.DETAILS.DATA' | translate"
    [expanded]="expandedCollapseSection === 'data'"
    (clickEvent)="toggleCollapse('data', $event)"
>
    @if (detail?.state_name === OPERATION_STATUS.INIT || detail?.state_name === OPERATION_STATUS.NOT_STARTED) {
        <tec-empty-state [title]="'OPERATIONS.DETAIL.TABS.DETAILS.EMPTY' | translate" [size]="'default'" [type]="'empty'" />
    } @else if (detail?.data?.mode === 'auto') {
        @if (detail?.data?.data?.length) {
            @for (tried of detail?.data?.data; track $index; let first = $first) {
                @if (isAutoPolTry(tried)) {
                    @if (!first) { <tec-divider /> }
                    <app-operation-pol-details-tried-data [tried]="tried" [index]="$index" />
                }
            }
        } @else {
            <tec-empty-state [title]="'OPERATIONS.DETAIL.TABS.DETAILS.EMPTY' | translate" [size]="'default'" [type]="'empty'" />
        }
    } @else {
        <span>{{ (detail?.state_name === OPERATION_STATUS.OK ? 'PROCESSES.DETAIL.POL_MANUAL_LIVENESS_OK' : 'PROCESSES.DETAIL.POL_MANUAL_LIVENESS_KO') | translate }}</span>
    }
</tec-collapse>

<!-- MEDIA -->
<tec-collapse
    [icon]="'icon-image'"
    [title]="'OPERATIONS.DETAIL.TABS.DETAILS.MEDIA' | translate"
    [expanded]="expandedCollapseSection === 'media'"
    (clickEvent)="toggleCollapse('media', $event)"
>
    @if (detail?.data?.images?.selfie?.length) {
        <app-operation-detail-tabs-details-media [detail]="detail" />
    } @else {
        <tec-empty-state [title]="'OPERATIONS.DETAIL.TABS.DETAILS.EMPTY' | translate" [size]="'default'" [type]="'empty'" />
    }
</tec-collapse>

<!-- OPERATION -->
<tec-collapse
    [icon]="'icon-pending-check'"
    [title]="'OPERATIONS.DETAIL.TABS.DETAILS.OPERATION' | translate"
    [expanded]="expandedCollapseSection === 'operation'"
    (clickEvent)="toggleCollapse('operation', $event)"
>
    <app-operation-detail-operation-meta
        [operationUuid]="polData?.uuid"
        [processUuid]="detail?.process_uuid"
        [startAt]="polData?.start_at"
        [endAt]="polData?.end_at"
        [totalTime]="polData?.total_time"
        triesStyle="tag"
        [triesLabel]="polTriesLabel()"
        [captureMethodLabel]="polCaptureMethodLabel()"
        [typeLabel]="polTypeLabel()"
        [verificationLabel]="polVerificationLabel()"
    />
</tec-collapse>
